var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_5299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8532 1.148C22.1733 0.469196 21.2519 0.0879364 20.2912 0.0879364C19.3305 0.0879364 18.409 0.469196 17.7292 1.148L1.46517 17.412C0.999419 17.8751 0.63013 18.426 0.378666 19.0328C0.127202 19.6396 -0.00144539 20.2902 0.000167569 20.947V23C0.000167569 23.2652 0.105524 23.5196 0.293061 23.7071C0.480597 23.8946 0.734951 24 1.00017 24H3.05317C3.70993 24.0019 4.36054 23.8734 4.96732 23.6221C5.57411 23.3708 6.12502 23.0017 6.58817 22.536L22.8532 6.271C23.5317 5.59119 23.9127 4.66997 23.9127 3.7095C23.9127 2.74903 23.5317 1.8278 22.8532 1.148ZM5.17417 21.122C4.61017 21.6822 3.84813 21.9977 3.05317 22H2.00017V20.947C1.99916 20.5529 2.07632 20.1625 2.2272 19.7985C2.37809 19.4344 2.59968 19.1039 2.87917 18.826L15.2222 6.483L17.5222 8.783L5.17417 21.122ZM21.4382 4.857L18.9322 7.364L16.6322 5.069L19.1392 2.562C19.2902 2.41131 19.4694 2.29184 19.6666 2.21041C19.8638 2.12898 20.0751 2.08719 20.2884 2.08742C20.5018 2.08765 20.713 2.1299 20.91 2.21176C21.107 2.29362 21.286 2.41348 21.4367 2.5645C21.5874 2.71552 21.7068 2.89474 21.7883 3.09193C21.8697 3.28913 21.9115 3.50042 21.9112 3.71377C21.911 3.92711 21.8688 4.13832 21.7869 4.33533C21.705 4.53235 21.5852 4.71131 21.4342 4.862L21.4382 4.857Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_5299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c01e501e7f2dcda1e07717fd22133ec8.svg";
export { ForwardRef as ReactComponent };